import { Contact } from './contact';
import { DateTime } from '../misc/dateutil';

export class QuickSMS {
  recipients: Contact[];
  sender: string;
  message: string;
  schedule: boolean;
  schedule_date?: string;
  datetime?: DateTime;

  constructor() {
    this.recipients = [];
    this.sender = '';
    this.message = '';
    this.schedule = false;
    this.datetime = null;
    this.schedule_date = '';
  }
}

export class MessageDeliverySummary {
  recipients: number;
  foreignRecipients: Contact[];
  invalidRecipients: Contact[];
  duplicates: Contact[];
  totalCost: number;
  messageParts: number;
  isLoading: boolean;

  constructor() {
    this.recipients = 0;
    this.foreignRecipients = [];
    this.invalidRecipients = [];
    this.duplicates = [];
    this.totalCost = 0;
    this.messageParts = 0;
    this.isLoading = true;
  }
}
